// Environment variables với fallback để tránh undefined
// Lưu ý: Fallback phải match với giá trị trong .env.production
export const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || 'https://api.c10depot.com/api';
export const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL || 'https://c10depot.com';
export const API_FILE_URL = process.env.NEXT_PUBLIC_API_FILE_URL || 'https://file.c10depot.com/api';
export const FILE_PREVIEW_URL = process.env.NEXT_PUBLIC_FILE_PREVIEW_URL || 'https://file.c10depot.com/api/File/download?fileTrackingId=';
export const NOMINATIM_URL = process.env.NEXT_PUBLIC_NOMINATIM_URL || 'https://nominatim.openstreetmap.org';


export const USER_TKN = 'token-client';
export const USER_TKN_SERVER = 'token-server';
